import { computed, defineComponent } from "@vue/composition-api";
import useUserPublicData from "@/hooks/useUserPublicData";
import { userPublicDataFieldsWithStoryInfo } from "@/lib/fieldsHelper";

export default defineComponent({
  name: "UsersOnlineController",
  setup(props, { emit }) {
    const { data, render, getFirstPage } = useUserPublicData(
      computed(() => ({ role: "creator", isOnline: true, discoveryOnly: true })),
      undefined,
      userPublicDataFieldsWithStoryInfo()
    );
    getFirstPage().then(() => emit("load", data.value?.totalRecords));
    return render;
  },
});
